<div class="dialog-container" [class.dialog-container--input]="data.type === DialogType.Input">
  <div class="dialog-header">
    <h3 class="dialog-heading">
      @if (isTitleString()) {
        <span [innerHTML]="getTitleString() | transloco"></span>
      } @else {
        <span
          [innerHTML]="getTitleObject().key | transloco: { value: getTitleObject().value }"></span>
      }
    </h3>
    <button
      formaIconButton="ghost-small"
      icon="x-bold"
      type="button"
      class="dialog-close"
      [attr.aria-label]="'INSIGHT.GLOBAL.CLOSE' | transloco"
      (click)="onSecondary()"></button>
  </div>

  <div class="dialog-body">
    @if (data.description) {
      <p class="dialog-description">{{ data.description | transloco }}</p>
    }
    @if (data.body) {
      <p
        class="dialog-body-text"
        [innerHTML]="data.body | transloco: { param: data.translationParameter }"></p>
    }
    @if (data.type === DialogType.Input) {
      <forma-form-field class="dialog-input-field">
        <label formaLabel>{{ data.label | transloco }}</label>
        <input formaInput type="text" [placeholder]="data.placeholder" [(ngModel)]="data.value" />
      </forma-form-field>
    }
  </div>

  <forma-button-group align="end" class="dialog-button-group">
    @if (data.falseOption) {
      <button formaButton="text" type="button" (click)="onSecondary()">
        {{ data.falseOption | transloco }}
      </button>
    }
    <button
      formaButton="primary"
      type="button"
      [attr.data-pendo-id]="data.trueOption"
      (click)="onPrimary()">
      {{ data.trueOption | transloco }}
    </button>
  </forma-button-group>
</div>
